import { Modal } from 'antd'
import { applyMiddleware, compose, createStore } from "redux";
import { routerMiddleware } from "react-router-redux";
import thunk from 'redux-thunk';
import createSagaMiddleware from "redux-saga";
// import createHistory from "history/createBrowserHistory";
import { createBrowserHistory } from 'history';

import appReducer from "../reducers/index";

import rootSaga from '../sagas/index';

import { SIGNOUT_USER_SUCCESS } from "../../appRedux/actions/Auth";

const { confirm } = Modal

// const history = createHistory();

const history = createBrowserHistory({
  basename: '', // The base URL of the app (see below)
  forceRefresh: false, // Set true to force full page refreshes
  keyLength: 6, // The length of location.key
  // A function to use to confirm navigation with the user (see below)
  getUserConfirmation: (message, callback) => {
    // confirm({
    //   title: message,
    //   onOk() {
    //     callback(true)
    //   },
    //   onCancel() {
    //     callback(false)
    //   }
    // })
  }
});

const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();


const middlewares = [thunk, sagaMiddleware, routeMiddleware];
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancers =
  (process.env.NODE_ENV !== 'production' &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

export default function configureStore(initialState) {


  //reset reducer state on LOGOUT
  const rootReducer = (state, action) => {
    if (action.type === SIGNOUT_USER_SUCCESS) {
      state = undefined;
    }
    return appReducer(state, action);
  }

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept(appReducer, () => {
      const nextRootReducer = require(appReducer);
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
export { history };
